import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_app_education_input = _resolveComponent("app-education-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-User-Profile-Modal App-Unpadded",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": _ctx.showClose,
      "close-on-click-modal": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Education",
      center: "",
      "append-to-body": false,
      "lock-scroll": true,
      "open-delay": 200,
      "close-delay": 200,
      "before-close": _ctx.closeModal,
      "close-on-press-escape": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.submit,
            size: "large",
            type: "primary",
            disabled: _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Save Education Info ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          always: true,
          "max-height": "600px"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_image, {
                    style: `width: 150px;`,
                    src: _ctx.img
                  }, null, 8, ["src"]),
                  _cache[1] || (_cache[1] = _createElementVNode("p", null, [
                    _createTextVNode(" Please tell us about "),
                    _createElementVNode("br"),
                    _createTextVNode(" your education history ")
                  ], -1))
                ])
              ]),
              _createVNode(_component_el_form, {
                onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                class: "App-Styled-Form",
                "label-position": 'top',
                "label-width": "100px",
                model: _ctx.form,
                style: {"margin-top":"12px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.education, (edu, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createVNode(_component_app_education_input, {
                        index: index,
                        modelValue: _ctx.form.education[index],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.education[index]) = $event),
                        onRemove: ($event: any) => (_ctx.removeEducation(index))
                      }, null, 8, ["index", "modelValue", "onUpdate:modelValue", "onRemove"])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_button, {
                      type: "info",
                      "is-borderless": "",
                      round: "",
                      onClick: _ctx.addEducation,
                      size: "small",
                      icon: "el-icon-plus"
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Add Education", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "close-on-click-modal", "onOpen", "before-close"])
  ]))
}